const Convenios = ({}) => {
  return <div>Hola Convenios</div>;
};
export default Convenios;
